import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Play from "assets/svg/play.svg";
import React, { FC } from "react";

import { Title } from "..";
import style from "./styles.module.css";

type Props = {
  frequentlyAskedQuestions: [
    | {
        description: string;
        id: number;
        title: string;
      }
    | any
  ];
  isHtml?: boolean;
};

const FAQ: FC<Props> = ({ frequentlyAskedQuestions, isHtml = false }) => {
  return (
    <div
      className={`h-auto w-full rounded px-0 py-5 transition-all md:py-5 md:px-0`}
      style={{
        contain: "content",
      }}
    >
      <div className={`relative transition-all`} style={{ contain: "content" }}>
        <Title
          type={null}
          title="سوالات متداول"
          wrapperClass="text-black-550 mb-5"
        />
        <div className="w-full space-y-[10px] py-2">
          {frequentlyAskedQuestions?.map(
            ({ description, id, title }, index: number) => (
              <>
                <details
                  key={JSON.stringify(`${id}`)}
                  className={`${style.details} border-r-4 !border-b-0 border-blue-550 !bg-white text-xs shadow md:text-sm`}
                >
                  <summary className={`${style.summary}`}>
                    <div className="flex w-full justify-between">
                      <div className="flex">
                        <span className="">{title}</span>
                      </div>
                      <div className="flex">
                        {/* <span className="ml-1 md:ml-3">10 ساعت</span> */}
                        <ArrowBottom className={style.arrow} />
                      </div>
                    </div>
                  </summary>
                  <ul className="space-y-[10px]">
                    <li className="mx-5  flex items-center justify-between rounded bg-white px-[10px] pt-[10px] text-xs md:text-sm">
                      {isHtml ? (
                        <div
                          className="leading-loose"
                          dangerouslySetInnerHTML={{ __html: description }}
                        />
                      ) : (
                        <p className="leading-loose">{description}</p>
                      )}
                    </li>
                  </ul>
                </details>
              </>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
